enum RouterPages {
  INDEX = 'Index',
  PRIVACY = 'Privacy',
  CHAT = 'Chat',
  CHAT_USER = 'ChatUser',
  CHAT_GROUP = 'ChatGroup',
  ERROR = 'Error',
  NOT_FOUND = 'NotFound',
}

enum RouterPaths {
  INDEX = '/',
  CHAT = '/chat',
  CHAT_USER = '/chat/u/:username',
  CHAT_GROUP = '/chat/g/:slug',
  PRIVACY = '/docs/privacy',
  ERROR = '/error',
}

enum ChatRouteKind {
  USER = 'u',
  GROUP = 'g',
}

export { ChatRouteKind, RouterPages, RouterPaths };
